export enum EMovementType {
  COMPRA = "COMPRA",
  SAQUE = "SAQUE",
}

export enum EVindiPaymentStatus {
  PROCESSING = "processing",
  SUCCESS = "success",
  REJECTED = "rejected",
  FAILURE = "failure",
  TIMEOUT = "timeout",
  WAITING = "waiting",
  CANCELED = "canceled",
  FRAUD_REVIEW = "fraud_review",
}
